export interface QualificationV2ConfigModule {
  csvBoxQualificationV2SheetLicense: string;
  csvBoxRouteQualificationV2SheetLicense: string;
}

export interface BulkEditQualificationSelectionHasMixedValues {
  acquiredAt: boolean;
  validFrom: boolean;
  validTill: boolean;
  confirmedByUser: boolean;
  notes: boolean;
}

export interface FilterValues {
  status: string[];
  userIds: string[];
  qualificationIds: string[];
}

export enum FlowDirection {
  LeftToRight = 'left-to-right',
  RightToLeft = 'right-to-left',
}

export interface TrainingQualificationsBulkEditSelectionHasMixedValues {
  name: boolean;
  label: boolean;
  status: boolean;
  notes: boolean;
}
